module.exports = __webpack_public_path__ + "static/img/par.66e82a2.svg";